import React, { useState, useEffect } from "react";
import { useMethods } from "../hooks/useMethods";

import {
  Box,
  Typography,
  Collapse,
  ClickAwayListener,
  Popper,
  Chip,
  Paper,
  IconButton,
  InputAdornment,
  TextField,
  Button,
  ListItem,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import {
  StatBox,
  MyChart,
  ChoosingMerchants,
  Loading,
  Error,
  PageHeader,
} from "../components";
import ChoosingMethods from "../components/ChoosingMethods";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { StaticDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentsIcon from "@mui/icons-material/Payments";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import InsightsRounded from "@mui/icons-material/InsightsRounded";
import { useMedia } from "../context/MediaContext";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Fade from "@mui/material/Fade";
import { alpha, useTheme } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import SettingsIcon from "@mui/icons-material/Settings";
import { rotate360 } from "../utils/utils";
import { Dayjs } from "dayjs";
import { useData } from "../hooks/useData";
import { getStats } from "../utils/api";
import { useAuthStore } from "../store/authStore";
dayjs.locale("ru");

export const makeLabels = (startDate: any, endDate: any) => {
  const newLabels = [];
  const newDisplayLabels = [];
  for (
    let time = new Date(startDate);
    time <= endDate;
    time.setMinutes(time.getMinutes() + 30)
  ) {
    const days = time.getDate().toString().padStart(2, "0");
    const month = (time.getMonth() + 1).toString().padStart(2, "0");
    const hours = time.getHours().toString().padStart(2, "0");
    const minutes = time.getMinutes().toString().padStart(2, "0");

    const fullLabel = `${days}/${month}-${hours}:${minutes}`;
    const displayLabel = `${hours}:${minutes}`;

    newLabels.push(fullLabel);
    newDisplayLabels.push(displayLabel);
  }

  return { newLabels, newDisplayLabels };
};
type TStats = {
  all_payin: number[];
  all_payin_success: number[];
  payin_given_count: number[];
  payin_given: number[];
  all_payin_success_count: number[];
  count_payin: number[];
  total_payin: number;
  provider_payin: number;
  provider_payin_percentage: number;
  success_payin: number;
  success_payin_percentage: number;
  total_payout: number;
  success_payout: number;
  avg_payin: number;
  avg_success_payin: number;
  success_payin_count: number;
  provider_payin_count: number;
  no_reqs: number;
  total_payin_count: number;
  success_by_providers: Record<number, number[]>;
};
const dictionary = {
  total_payin: { name: "Трафика в нашу сторону", icon: AccountBalanceIcon },
  provider_payin: { name: "Выдано реквизитов на сумму", icon: PaymentsIcon },
  success_payin: {
    name: "Всего обработано трафика",
    icon: AccountBalanceWalletIcon,
  },
  success_payout: { name: "Успешно выплатили", icon: ThumbUpIcon },
  total_payout: { name: "Всего выплат", icon: CreditCardIcon },
  avg_payin: { name: "Средний чек по всем ордерам", icon: AccountBalanceIcon },
  avg_success_payin: {
    name: "Средний чек по успешным ордерам",
    icon: AccountBalanceIcon,
  },
  success_payin_count: {
    name: "Всего успешных ордеров за сегодня",
    icon: AccountBalanceIcon,
  },
  provider_payin_count: { name: "Всего выдали реков", icon: CreditCardIcon },
  no_reqs: { name: "Не выдали реков", icon: ThumbDownIcon },
  total_payin_count: { name: "Всего ордеров за сегодня", icon: PaymentsIcon },
};
const StatPage = () => {
  const theme = useTheme();
  const { curr } = useAuthStore();
  const { isTablet, isMobile600 } = useMedia();
  const [selectedMerch, setSelectedMerch] = useState<number[]>([]);
  const [selectedMethod, setSelectedMethod] = useState<string[]>([]);
  const { merchants, providers } = useData();
  const [err, setErr] = useState<string | null>(null);
  const [chartType, setChartType] = useState("трафик");
  const [secondChartType, setSecondChartType] = useState<string>("запросы");
  const [update, setUpdate] = useState<string>("Общий трафик");
  const [forwardedSum, setForwardedSumm] = useState<{
    ammountFrom: number;
    ammountTo: number;
  }>({ ammountFrom: 0, ammountTo: 0 });
  const { methods } = useMethods();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<TStats | null>(null);
  const [forwardMethod, setForwardMethod] = useState<string[]>([]);

  const [forwardMerch, setForwardMerch] = useState<number[]>([]);
  const [settingsOpen, setSettingsOpen] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<string | null>(null);
  const [selectedSumm, setSelectedSum] = useState({
    ammountFrom: "",
    ammountTo: "",
  });

  const [date, setDate] = useState<Dayjs | null>(dayjs());
  const [anchorEl, setAnchorEl] = useState(null);

  const chartHeaderSx = {
    minHeight: 52,
    borderRadius: "25px 25px 0 0",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: 0,
  } as const;

  const chartTitleSx = {
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.secondary,
  } as const;

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const loadStats = async (
    date: string,
    merchid: number[],
    amountFrom: number,
    amountTo: number,
    methods: string[],
  ) => {
    setLoading(true);
    try {
      try {
        const res = await getStats(
          date,
          merchid,
          amountFrom,
          amountTo,
          curr.toLowerCase(),
          methods,
        );
        setStats(res.data);
      } catch (error) {
        setErr("Ошибка получения статистики.");
        console.error("Ошибка при получении статистики:", error);
      }
    } finally {
      setLoading(false);
      if (selectedSumm) {
        setDisabled(null);
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    setSelectedMerch(merchants.map((el) => el.id));
    setForwardMerch(merchants.map((el) => el.id));
  }, [merchants]);
  useEffect(() => {
    if (selectedMerch.length > 0) {
      const ammountFrom = forwardedSum?.ammountFrom;
      const ammountTo = forwardedSum?.ammountTo;

      loadStats(
        dayjs(date).format("DD.MM.YYYY"),
        selectedMerch,
        ammountFrom,
        ammountTo,
        selectedMethod,
      );
    }
  }, [date, selectedMerch, forwardedSum, curr, selectedMethod]);

  if (loading) {
    return <Loading variant="dashboard" />;
  }

  if (err) {
    return <Error error={err} />;
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      <Box
        sx={{
          width: "100%",
          paddingTop: "25px",
          maxHeight: "calc(var(--content-max-height) + 22dvh)",
          overflow: "auto",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            width: "94%",
            margin: "0 auto",
          }}
        >
          <PageHeader
            title="Статистика"
            description="Ключевые показатели и динамика операций"
            icon={InsightsRounded}
            actions={
              <>
                <Chip
                  icon={<CalendarTodayIcon />}
                  label={dayjs(date).format("DD/MM/YYYY")}
                  onClick={handleClick}
                  color="primary"
                  sx={{ height: 42, px: 0.5, cursor: "pointer" }}
                />
                <IconButton
                  aria-label="Настройки статистики"
                  onClick={() => setSettingsOpen(!settingsOpen)}
                  sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    "&:hover svg": {
                      animation: `${rotate360} 1.5s linear infinite`,
                    },
                  }}
                >
                  <SettingsIcon />
                </IconButton>
              </>
            }
          />
          <Popper
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            transition
            sx={{
              zIndex: 10,
              transformOrigin: "top",
            }}
            modifiers={[
              {
                name: "preventOverflow",
                options: {
                  boundary: "window",
                },
              },
              {
                name: "offset",
                options: {
                  offset: isMobile600 ? [0, 0] : [-100, 0],
                },
              },
            ]}
          >
            {({ TransitionProps }) => (
              <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                <Fade {...TransitionProps} timeout={300}>
                  <Box
                    sx={{
                      transform: "scale(1)",
                      bgcolor: "background.paper",
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow:
                        theme.palette.mode === "dark"
                          ? "0 24px 60px rgba(0,0,0,.5)"
                          : "0 24px 60px rgba(30,42,74,.16)",
                      transition: "transform 0.2s ease-in-out",
                      "& .MuiPickersLayout-root": {
                        backgroundColor: "transparent",
                      },
                      "& .MuiPickersToolbar-root .MuiTypography-root": {
                        color: theme.palette.text.primary,
                      },
                      "& .MuiDayCalendar-weekDayLabel": {
                        color: theme.palette.text.secondary,
                      },
                      "& .MuiPickersDay-root": {
                        color: theme.palette.text.primary,
                      },
                    }}
                  >
                    <StaticDatePicker
                      value={date}
                      maxDate={dayjs()}
                      onChange={(newDate) => {
                        setDate(newDate);
                        setAnchorEl(null);
                      }}
                      slotProps={{ actionBar: { actions: [] } }}
                      localeText={{ toolbarTitle: "Выберите дату" }}
                    />
                  </Box>
                </Fade>
              </ClickAwayListener>
            )}
          </Popper>
        </Box>
        <Collapse in={settingsOpen}>
          <Box
            paddingTop={"25px"}
            display={"flex"}
            flexDirection={isTablet ? "column" : "row"}
            justifyContent={"space-between"}
            width={"95%"}
            margin="0 auto"
            gap="10px"
          >
            <ChoosingMerchants
              setSelectedMerch={setSelectedMerch}
              forwardMerch={forwardMerch}
              setForwardMerch={setForwardMerch}
              merchants={merchants}
              setForwardedSumm={setForwardedSumm}
              selectedSumm={selectedSumm}
            />
            <ChoosingMethods
              selectedMethod={selectedMethod}
              forwardMethods={forwardMethod}
              setForwardMethods={setForwardMethod}
              methods={methods}
            />
            <Box
              display="flex"
              alignItems="center"
              gap="15px"
              flexDirection={isMobile600 ? "column" : "row"}
              marginTop={isTablet ? "15px" : 0}
              width={isTablet ? "100%" : "50%"}
            >
              <Typography alignSelf={isMobile600 ? "start" : "center"}>
                От
              </Typography>
              <TextField
                type="text"
                placeholder="Введите сумму"
                name="ammountFrom"
                onChange={(e) => {
                  const raw = e.target.value.replace(/\s/g, "");
                  const numeric = raw.replace(/[^\d]/g, "");
                  setSelectedSum((prev) => ({
                    ...prev,
                    ammountFrom: numeric,
                  }));
                }}
                value={
                  selectedSumm.ammountFrom
                    ? Number(selectedSumm.ammountFrom).toLocaleString("ru-RU")
                    : ""
                }
                disabled={
                  disabled === null || disabled === "ammountTo" ? true : false
                }
                variant="outlined"
                sx={{
                  width: isMobile600 ? "100%" : "45%",
                  height: "45px",
                  "& .MuiInputBase-root": {
                    height: "100%",
                    paddingRight: 0,
                  },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end" sx={{ p: 0, pr: 1 }}>
                        <IconButton
                          onClick={() =>
                            disabled === "ammountFrom"
                              ? setDisabled(null)
                              : setDisabled("ammountFrom")
                          }
                          sx={{ p: 0 }}
                        >
                          {disabled === "ammountFrom" ? (
                            <EditOffIcon />
                          ) : (
                            <EditIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />

              <Typography alignSelf={isMobile600 ? "start" : "center"}>
                До
              </Typography>
              <TextField
                placeholder="Введите сумму"
                type="text"
                name="ammountTo"
                onChange={(e) => {
                  const raw = e.target.value.replace(/\s/g, "");
                  const numeric = raw.replace(/[^\d]/g, "");

                  setSelectedSum((prev) => ({
                    ...prev,
                    ammountTo: numeric,
                  }));
                }}
                value={
                  selectedSumm.ammountTo
                    ? Number(selectedSumm.ammountTo).toLocaleString("ru-RU")
                    : ""
                }
                disabled={
                  disabled === null || disabled === "ammountFrom" ? true : false
                }
                variant="outlined"
                sx={{
                  width: isMobile600 ? "100%" : "45%",
                  height: "45px",
                  "& .MuiInputBase-root": {
                    height: "100%",
                    paddingRight: 0,
                  },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "& input[type=number]": {
                    MozAppearance: "textfield",
                  },
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end" sx={{ p: 0, pr: 1 }}>
                        <IconButton
                          onClick={() =>
                            disabled === "ammountTo"
                              ? setDisabled(null)
                              : setDisabled("ammountTo")
                          }
                          sx={{ p: 0 }}
                        >
                          {disabled === "ammountTo" ? (
                            <EditOffIcon />
                          ) : (
                            <EditIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Box>
            <Box
              width={isTablet ? "100%" : "auto"}
              minWidth={isTablet ? undefined : 140}
              margin="15px auto 0"
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                variant="contained"
                disabled={forwardMerch.length === 0}
                sx={{ width: "100%", whiteSpace: "nowrap" }}
                onClick={() => {
                  setSelectedMerch(forwardMerch);
                  setSelectedMethod(forwardMethod);
                  setForwardedSumm({
                    ammountFrom: Number(selectedSumm.ammountFrom),
                    ammountTo: Number(selectedSumm.ammountTo),
                  });
                }}
              >
                Загрузить
              </Button>
            </Box>
          </Box>
        </Collapse>
        <Box
          role="tablist"
          aria-label="Разрез статистики"
          sx={{
            display: "flex",
            gap: 0.5,
            width: "90%",
            margin: "0 auto",
            mt: 3,
            p: 0.5,
            borderRadius: "14px",
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          {["Общий трафик", "Провайдеры"].map((label) => {
            const selected = update === label;
            return (
              <Box
                key={label}
                component="button"
                type="button"
                role="tab"
                aria-selected={selected}
                onClick={() => setUpdate(label)}
                sx={{
                  flex: 1,
                  minHeight: 40,
                  border: 0,
                  cursor: "pointer",
                  borderRadius: "10px",
                  fontSize: 14,
                  fontWeight: selected ? 700 : 560,
                  color: selected
                    ? theme.palette.primary.main
                    : theme.palette.text.secondary,
                  backgroundColor: selected
                    ? alpha(theme.palette.primary.main, 0.12)
                    : "transparent",
                  transition: "background-color 160ms ease, color 160ms ease",
                  "&:hover": {
                    backgroundColor: alpha(
                      theme.palette.primary.main,
                      selected ? 0.16 : 0.06,
                    ),
                  },
                }}
              >
                {label}
              </Box>
            );
          })}
        </Box>
        <Box
          sx={{
            margin: "0 auto",
            height: "70vh",
            marginTop: "25px",
            width: "95%",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gridTemplateRows: "auto",
              width: "90%",
              margin: "0 auto",
              gap: "25px",
              marginBottom: "50px",
            }}
          >
            {update === "Общий трафик"
              ? stats &&
                (Object.entries(stats) as [keyof TStats, number | number[]][])
                  .filter(
                    ([key]) =>
                      key !== "all_payin" &&
                      key !== "provider_payin_percentage" &&
                      key !== "success_payin_percentage" &&
                      key !== "success_by_providers" &&
                      key !== "count_payin",
                  )
                  .map(([key, value]) => {
                    const dictEntry =
                      dictionary[key as keyof typeof dictionary];
                    if (!dictEntry) return null;

                    return (
                      <StatBox
                        key={key}
                        name={dictEntry.name}
                        icon={dictEntry.icon}
                        successPercent={stats.success_payin_percentage}
                        providerPercent={stats.provider_payin_percentage}
                        sum={value as number}
                      />
                    );
                  })
              : stats &&
                (
                  Object.entries(stats.success_by_providers) as [
                    keyof TStats,
                    number | number[],
                  ][]
                ).map(([key, value]) => {
                  const provider = providers.find(
                    (prov) => prov.id === Number(key),
                  );
                  const name = provider?.name ?? "Неизвестный провайдер";
                  const success = Array.isArray(value) ? value[0] : value;
                  const total = Array.isArray(value) ? value[1] : value;
                  const totalOrders = Array.isArray(value) ? value[3] : value;
                  const successOrders = Array.isArray(value) ? value[2] : value;

                  const conversion =
                    total > 0 ? Math.round((success / total) * 100) : 0;

                  return (
                    <Paper
                      key={key}
                      sx={{
                        borderRadius: "18px",
                        minWidth: "250px",
                        p: 2.5,
                        transition: "transform 180ms ease, box-shadow 180ms ease",
                        "&:hover": {
                          transform: "translateY(-3px)",
                          borderColor: alpha(theme.palette.primary.main, 0.4),
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ fontSize: 18, lineHeight: 1.2 }}
                        >
                          {name}
                        </Typography>
                        <Chip
                          size="small"
                          label={`${conversion}%`}
                          sx={{
                            fontWeight: 700,
                            color:
                              conversion >= 60
                                ? theme.palette.success.main
                                : conversion >= 30
                                  ? theme.palette.warning.main
                                  : theme.palette.error.main,
                            backgroundColor: alpha(
                              conversion >= 60
                                ? theme.palette.success.main
                                : conversion >= 30
                                  ? theme.palette.warning.main
                                  : theme.palette.error.main,
                              0.12,
                            ),
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 1.5,
                        }}
                      >
                        {[
                          { label: "Общий трафик", value: total },
                          { label: "Успешный", value: success },
                          { label: "Кол-во заявок", value: totalOrders },
                          { label: "Успешные заявки", value: successOrders },
                        ].map((row) => (
                          <Box key={row.label}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: "block", fontSize: 12 }}
                            >
                              {row.label}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: 17,
                                fontWeight: 700,
                                fontVariantNumeric: "tabular-nums",
                              }}
                            >
                              {row.value.toLocaleString("ru-RU")}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Paper>
                  );
                })}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "25px",
              width: isTablet ? "100%" : "calc(100vw - 250px)",
              margin: "0 auto",
            }}
          >
            <Box>
              <ListItem sx={chartHeaderSx}>
                <Typography variant="h6" sx={chartTitleSx}>
                  Общий ввод
                </Typography>
              </ListItem>

              <Paper
                sx={{
                  borderRadius: "0 0 25px 25px",
                  borderTop: 0,
                  overflow: "hidden",
                  position: "relative",
                  padding: "25px 0 25px 0",
                }}
              >
                <Box display="flex" gap="10px" margin="5px 0 5px 20px">
                  {["трафик", "заявки"].map((type) => (
                    <Chip
                      key={type}
                      label={type}
                      clickable
                      color={chartType === type ? "primary" : "default"}
                      onClick={() => setChartType(type)}
                      sx={{
                        fontWeight: chartType === type ? 700 : 500,
                      }}
                    />
                  ))}
                </Box>

                <MyChart
                  selectedDate={
                    dayjs(date).isSame(dayjs(), "day") ? null : date
                  }
                  isMobile={isMobile600}
                  stats={{
                    main:
                      chartType === "трафик"
                        ? (stats?.all_payin ?? [])
                        : (stats?.count_payin ?? []),
                    success: stats?.all_payin_success_count ?? [],
                    allrequest: stats?.payin_given_count ?? [],
                  }}
                  chartType={chartType}
                />
              </Paper>
            </Box>
            <Box>
              <ListItem sx={chartHeaderSx}>
                <Typography variant="h6" sx={chartTitleSx}>
                  Принятые / успешные запросы
                </Typography>
              </ListItem>

              <Paper
                sx={{
                  borderRadius: "0 0 25px 25px",
                  borderTop: 0,
                  overflow: "hidden",
                  position: "relative",
                  padding: "25px 0 25px 0",
                }}
              >
                <Box display="flex" gap="10px" margin="5px 0 5px 20px">
                  {["запросы", "сумма"].map((type) => (
                    <Chip
                      key={type}
                      label={type}
                      clickable
                      color={secondChartType === type ? "primary" : "default"}
                      onClick={() => setSecondChartType(type)}
                      sx={{
                        fontWeight: chartType === type ? 700 : 500,
                      }}
                    />
                  ))}
                </Box>
                <MyChart
                  selectedDate={
                    dayjs(date).isSame(dayjs(), "day") ? null : date
                  }
                  isMobile={isMobile600}
                  stats={{
                    main:
                      secondChartType === "запросы"
                        ? (stats?.payin_given_count ?? [])
                        : (stats?.payin_given ?? []),
                    success:
                      secondChartType === "запросы"
                        ? (stats?.all_payin_success_count ?? [])
                        : (stats?.all_payin_success ?? []),
                  }}
                  chartType={secondChartType}
                />
              </Paper>
            </Box>
          </Box>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default StatPage;
